/**
 * Shared ECharts chart color palette resolved from CSS custom properties.
 * Mirrors JsxgraphThemeService: reads --neutral-* / --sky-* at runtime
 * so charts automatically follow the active light / dark theme.
 *
 * ECharts parses color values internally (for gradients, opacity, etc.)
 * so CSS var() strings cannot be used directly — resolved hex values are required.
 */

export interface EchartsChartColors {
  /** Axis lines (x / y main line). --neutral-300. */
  axis: string;
  /** Grid / split lines. --neutral-100. */
  grid: string;
  /** Axis labels, value labels. --neutral-500. */
  text: string;
  /** Default (inactive) bar / series fill. --neutral-200. */
  barDefault: string;
  /** DataZoom accent colors. */
  dataZoom: {
    border: string;
    fill: string;
    bg: string;
    accent: string;
  };
}

export function readEchartsChartColors(doc: Document): EchartsChartColors {
  const style = getComputedStyle(doc.body);
  const v = (name: string, shade: number) => style.getPropertyValue(`--${name}-${shade}`).trim();

  return {
    axis: v('neutral', 300),
    grid: v('neutral', 100),
    text: v('neutral', 500),
    barDefault: v('neutral', 200),
    dataZoom: {
      border: v('sky', 200),
      fill: v('sky', 100),
      bg: v('sky', 50),
      accent: v('sky', 500),
    },
  };
}
